// Backbone.Validation v0.4.0
//
// Copyright (C)2011 Thomas Pedersen
// Distributed under MIT License
//
// Documentation and full license availabe at:
// http://github.com/thedersen/backbone.validation

Backbone.Validation = (function(Backbone, _, undefined) {
  var defaultOptions = {
    forceUpdate: false,
    selector: 'name'
  };

  var getValidators = function(view, attr) {
    var validation = view.validation[attr] || {};

    if (_.isFunction(validation)) {
      return validation;
    } else if (_.isString(validation)) {
      return model[validation];
    } else if (!_.isArray(validation)) {
      validation = [validation];
    }

    return _.reduce(validation, function(memo, validation) {
      _.each(_.without(_.keys(validation), 'msg'), function(validator) {
        memo.push({
          fn: Backbone.Validation.validators[validator],
          val: validation[validator],
          msg: validation.msg
        });
      });
      return memo;
    }, []);
  };

  var validateAttr = function(view, model, attr, value) {
    var validators = getValidators(view, attr);

    var d = $.Deferred(),
    messages = [];

    var arr = _.map(validators, function(validator, key) {
      // Return a deferred object for each validation and send error msg
      return $.Deferred(function(deferred) {
        // Pass these things to the validator
        var result = validator.fn(value, attr, validator.val, view, model);
        if (typeof result == 'object') {
          result.done(function(result) {
            deferred.resolve(result);
          });
        } else {
          deferred.resolve(result);
        }
      }).done(function(msg) {
        // If we have false or undefined we want to push that, not the default
        msg ? messages.push(validator.msg || msg) : messages.push(msg);
      });
    });

    $.when.apply(this, arr).then(function() {
      // Reduce messages into one
      var error = _.reduce(messages, function(memo, result) {
        // Required will take precedence over all errors
        if (result === false || memo === false) {
          return false;
        }
        // Get first in array
        if (result && !memo) {
          return result;
        }
        return memo;
      }, '');

      d.resolve(error);
    });

    return d.promise();
  };

  // Takes a view and a has of attributes to validate
  var validate = function(view, model, attrs) {
    var selector = defaultOptions.selector,
    validFn = defaultOptions.valid || Backbone.Validation.callbacks.valid,
    invalidFn = defaultOptions.invalid || Backbone.Validation.callbacks.invalid,
    invalidAttrs = [],
    d = $.Deferred();


    var arr = _.map(attrs, function(value, attr) {
      // Return deferred object for each validated Attr, send error message
      return $.when(validateAttr(view, model, attr, value)).done(function(error) {
        if (error) {
          invalidAttrs.push(attr);
          invalidFn(view, attr, error, selector);
        } else {
          validFn(view, attr, selector);
        }
      });
    });

    $.when.apply(this, arr).then(function() {
      d.resolve(attrs, invalidAttrs, view);
    });

    return d.promise();
  };

  // Field changed function
  var fieldChanged = function(view, model, e, key) {
    var $elem = $(e.currentTarget);

    var tmp = {};
    if ($elem.is(':checkbox')) {
      tmp[key] = $elem.is(":checked") ? 1 : 0;
    } else {
      tmp[key] = $elem.val();
    }

    // Pass in a hash of attributes to validate
    $.when(validate(view, model, tmp)).then(function(attrs, invalidAttrs) {
      // You could use these to display like an aggregate error message or nothing

      //console.log('Valid attr: ', attrs);
      //console.log('Invalid attr: ', invalidAttrs);

      // If we have no errors, passing it to the cloned item
      if (invalidAttrs.length == 0){
        model.set(attrs);
      }
    });
  };

  return {
    version: '0.1.0',

    configure: function(options) {
      _.extend(defaultOptions, options);
    },

    error: function(view, attr, error) {
      var selector = defaultOptions.selector,
      validFn = defaultOptions.valid || Backbone.Validation.callbacks.valid,
      invalidFn = defaultOptions.invalid || Backbone.Validation.callbacks.invalid;

      invalidFn(view, attr, error, selector);
    },

    clearError: function(view, attr) {
      var selector = defaultOptions.selector,
      validFn = defaultOptions.valid || Backbone.Validation.callbacks.valid,
      invalidFn = defaultOptions.invalid || Backbone.Validation.callbacks.invalid;

      validFn(view, attr, selector);
    },

    bind: function(view, model, options) {
      _.extend(defaultOptions, options);

      var selector = defaultOptions.selector;

      // Populate form fields and bind events
      _.each(view.validation, function(value, key, list) {
        // Set up the initial view values based on the model
        var $elem = view.$('[' + selector + '~="' + key + '"]');
        if ($elem.is(':checkbox')) {
          model.get(key) == 1 ? $elem.prop('checked', true) : $elem.prop('checked', false);
        } else if ($elem.is(':radio')) {
          $elem.filter('[value="' + model.get(key) + '"]').prop('checked', true);
        } else {
          $elem.val(model.get(key));
        }
        view.trigger('form:changed', model);

        // Set the cropper if it exists
        if($elem.closest('.form-group-upload__profile').length > 0){
          $elem.closest('.form-group-upload').find('.button-upload').on('click', function(e){
            e.preventDefault();

            var cropperView = new cv.ProfileCropperView({
              view: view,
              key: key,
              model: model
            });

            vent.trigger('modal:show', cropperView);
          });
        }
        // See if the form upload exists
        if($elem.closest('.form-group-upload').length > 0){
          $elem.closest('.form-group-upload').find('.fileupload').fileupload({
            url : '//causevox-production.s3.amazonaws.com',
            paramName: 'file',
            beforeSend: function(jqXHR) {
            },
            dropZone : null,
            //forceIframeTransport: true,
            add: _.bind(function(e, data) {
              console.log('Uploaded file', data.originalFiles[0]);

              var upload_errors = 0;
              var acceptFileTypes = /^image\/(gif|jpe?g|png)$/i;
              if(data.originalFiles[0]['type'] == '' || !acceptFileTypes.test(data.originalFiles[0]['type'])){
                vent.trigger('notif:error', 'That file is not a valid image.');
                upload_errors++;           
              }
              if(data.originalFiles[0]['size'] == '' || data.originalFiles[0]['size'] > 5000000) {
                vent.trigger('notif:error', 'That file is too large.  Please upload a file under 5 MB.');
                upload_errors++;
              }
              if(upload_errors == 0){
                // Generate the policy
                $.ajax({
                  url: cv.api_path + '/editor/generate_policy',
                  type: 'POST',
                  data : {
                    file_extension : data.originalFiles[0].name.split('.').pop().toLowerCase()
                  },
                  dataType: 'json',
                  async: false,
                  beforeSend: function(jqXHR){
                    jqXHR.setRequestHeader('Apikey', cv.PRELOADED.api_key);
                  },
                  success: _.bind(function(response) {
                    data.formData = {
                      key : response.key,
                      AWSAccessKeyId : response.access_key,
                      policy : response.policy,
                      signature : response.signature,
                      acl : 'public-read',
                      success_action_status : '201',
                      'X-Requested-With' : 'xhr',
                      'Content-Type' : data.originalFiles[0].name.split('.').pop()
                    };
                  }, this),
                  error: _.bind(function(result, textStatus, jqXHR) {
                    vent.trigger('notif:error', 'There was an error generating the S3 policy.');
                    $elem.closest('.form-group-upload').addClass('has-error');
                    return false;
                  }, this)
                });

                data.submit();
              }else{
                $elem.closest('.form-group-upload').addClass('has-error');
              }
            }, this),
            send: _.bind(function(result, textStatus, jqXHR){
              $elem.closest('.form-group-upload').find('.button-upload span').html('Uploading...');
            }, this),
            success: _.bind(function(result, textStatus, jqXHR){
              var s3_key = '/' + $(jqXHR.responseXML).find('Key').text();
              var s3_url = $(jqXHR.responseXML).find('Location').text();

              // Set the value in the model
              var tmp = {};
              tmp[key] = s3_key;
              model.set(tmp);

              // Refresh the photo and reset the form
              view.trigger('form:refresh_photo', key);
              $elem.trigger('change');
              $elem.closest('.form-group-upload').removeClass('has-error');
              $elem.closest('.form-group-upload').find('.button-upload span').html('Upload');
            }, this),
            error: _.bind(function(result, textStatus, jqXHR){
              vent.trigger('notif:error', 'Unknown Error');
              $elem.closest('.form-group-upload').addClass('has-error');
              $elem.closest('.form-group-upload').find('.button-upload span').html('Upload');
            }, this)
          });

          delete(view.validation[key].min_width);
          delete(view.validation[key].min_height);
        }

        // Undelegate the view change event
        view.$el.undelegate('[' + selector + '~="' + key + '"]', 'change');
        view.$el.undelegate('[' + selector + '~="' + key + '"]', 'focus');
        view.$el.undelegate('[' + selector + '~="' + key + '"]', 'blur');

        // Trigger a change events for any autofills, etc at the start which will trigger validation
        // Don't trigger hidden or radio elements (bug where it will choose the last one item)
        if($elem.css('visibility') != 'hidden' && !$elem.is(':radio')){
          $elem.trigger('change');
        }

        // Bind the model change events to the view
        view.listenTo(model, 'change:' + key, function(model, value) {
          var $elem = view.$('[' + selector + '~="' + key + '"]');
          if ($elem.is(':checkbox')) {
            model.get(key) == 1 ? $elem.prop('checked', true) : $elem.prop('checked', false);
          } else if ($elem.is(':radio')) {
            $elem.filter('[value="' + model.get(key) + '"]').prop('checked', true);
          } else {
            $elem.val(model.get(key));
          }
          view.trigger('form:changed', model);
        }, view);

        // Bind view change events to the model (will trigger validation)
        view.$el.delegate('[' + selector + '~="' + key + '"]', 'change', _.bind(function(e) {
          return fieldChanged(view, model, e, key);
        }, view));
        view.$el.delegate('[' + selector + '~="' + key + '"]', 'focus', _.bind(function(e) {
          view.$('[' + selector + '~="' + key + '"]').closest('.form-group').addClass('has-focus');
        }, view));
        view.$el.delegate('[' + selector + '~="' + key + '"]', 'blur', _.bind(function(e) {
          view.$('[' + selector + '~="' + key + '"]').closest('.form-group').removeClass('has-focus');
        }, view));
      }, this);

      view._validate = function() {
        var updateAttrs = {};

        // Validate all the things
        _.each(this.validation, function(value, key, list) {
          var $elem = view.$('[' + selector + '~="' + key + '"]');

          // Do diff things based on checkbox or something else
          if ($elem.is(':checkbox')) {
            updateAttrs[key] = $elem.is(":checked") ? 1 : 0;
          } else {
            updateAttrs[key] = $elem.val();
          }

          if ($elem.is(':text') || $elem.is(':password')) {
            // Trigger change events for autofills, etc at the start.
            $elem.trigger('change');
          }
        });

        return validate(view, model, updateAttrs);
      }
    },

    unbind: function(view) {
      if(view.$('.fileupload').length > 0){
        view.$('.fileupload').fileupload('destroy');
      }
    }
  };
}(Backbone, _));

Backbone.Validation.callbacks = {
  valid: function(view, attr, selector) {
    view.$('[' + selector + '~=' + attr + ']')
    .removeClass('invalid')
    .removeAttr('data-error');
  },

  invalid: function(view, attr, error, selector) {
    view.$('[' + selector + '~=' + attr + ']')
    .addClass('invalid')
    .attr('data-error', error);
  }
};

Backbone.Validation.patterns = {
  digits: /^\d+$/,
  number: /^-?(?:\d+|\d{1,3}(?:\d{3})+)(?:\.\d+)?$/,
  /* email: /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, */
  email : /^(\s*)[^\s@]+@[^\s@]+\.[^\s@]+(\s*)$/i,
  url: /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
};

Backbone.Validation.messages = {
  required: '{0} is required',
  requireCheck: '{0} is required',
  acceptance: '{0} must be accepted',
  isInteger: '{0} must be a whole number',
  min: '{0} must be greater than or equal to {1}',
  max: '{0} must be less than or equal to {1}',
  range: '{0} must be between {1} and {2}',
  length: '{0} must be {1} characters',
  minLength: '{0} must be at least {1} characters',
  maxLength: '{0} must be at most {1} characters',
  rangeLength: '{0} must be between {1} and {2} characters',
  oneOf: '{0} must be one of: {1}',
  equalTo: '{0} must be the same as {1}',
  pattern: '{0} must be a valid {1}'
};

Backbone.Validation.validators = (function(patterns, messages, _) {
  var trim = String.prototype.trim ?
  function(text) {
    return text === null ? '' : String.prototype.trim.call(text);
  } :
  function(text) {
    var trimLeft = /^\s+/,
    trimRight = /\s+$/;

    return text === null ? '' : text.toString().replace(trimLeft, '').replace(trimRight, '');
  };
  var format = function() {
    var args = Array.prototype.slice.call(arguments);
    var text = args.shift();
    return text.replace(/\{(\d+)\}/g, function(match, number) {
      return typeof args[number] != 'undefined' ? args[number] : match;
    });
  };
  var isNumber = function(value) {
    return _.isNumber(value) || (_.isString(value) && value.match(patterns.number));
  };
  var hasValue = function(value) {
    return !(_.isNull(value) || _.isUndefined(value) || (_.isString(value) && trim(value) === ''));
  };
  var isInteger = function(value) {
    var intRegex = /^\d+$/;
    return intRegex.test(value);
  };

  return {
    fn: function(value, attr, fn, view, model) {
      if (_.isString(fn)) {
        fn = model[fn];
      }
      return fn.call(model, value, attr);
    },
    required: function(value, attr, required, view, model) {
      var isRequired = _.isFunction(required) ? required.call(view) : required;
      if (!isRequired) {
        return false; // overrides all other validators
      }
      if (isRequired && !hasValue(value)) {
        return format(messages.required, attr);
    }
  },
  requireCheck: function(value, attr, customValue, view, model) {
    if (value == 0) {
      return format(messages.requireCheck, attr, customValue);
    }
  },
  check_email: function(value, attr, customValue, view, model) {
    if (hasValue(value)) {
      return $.ajax(customValue, {
        data: {
          email: value
        },
        type: 'get',
        dataType: 'html'
      });
    }
  },
  valid_custom_domain: function(value, attr, customValue, view, model) {
    if (hasValue(value)) {
      return $.ajax(cv.api_path + '/campaigns/valid_custom_domain', {
        data: {
          domain_name: value,
          campaign_id: model.get('id'),
        },
        type: 'get',
        dataType: 'html'
      });
    }
  },
  valid_domain: function(value, attr, customValue, view, model) {
    if (hasValue(value)) {
      return $.ajax(cv.api_path + '/campaigns/valid_domain', {
        data: {
          domain_name: value,
          campaign_id: model.get('id'),
        },
        type: 'get',
        dataType: 'html'
      });
    }
  },
  check_contact_email : function(value, attr, customValue, view, model) {
    if (hasValue(value)) {
      return $.ajax(cv.api_path + '/contacts/check_email', {
        data: {
          email: value,
          id: model.get('id'),
          organization_id : model.get('organization.id')
        },
        type: 'post',
        dataType: 'html'
      });
    }
  },
  valid_group_label : function(value, attr, customValue, view, model) {
    if (hasValue(value)) {
      return $.ajax(cv.api_path + '/groups/valid_label', {
        data: {
          label: value,
          id: model.get('id'),
          organization_id : model.get('organization.id')
        },
        type: 'post',
        dataType: 'html'
      });
    }
  },
  valid_project_stub: function(value, attr, customValue, view, model) {
    if (hasValue(value)) {
      return $.ajax(cv.api_path + '/projects/valid_stub', {
        data: {
          stub: value,
          id: model.get('id'),
          campaign_id : model.get('campaign.id')
        },
        type: 'post',
        dataType: 'html'
      });
    }
  },
  valid_team_stub: function(value, attr, customValue, view, model) {
    if (hasValue(value)) {
      return $.ajax(cv.api_path + '/teams/valid_stub', {
        data: {
          stub : value,
          id: model.get('id'),
          campaign_id : model.get('campaign.id')
        },
        type: 'post',
        dataType: 'html'
      });
    }
  },
  valid_post_stub: function(value, attr, customValue, view, model) {
    if (hasValue(value)) {
      return $.ajax(cv.api_path + '/posts/valid_stub', {
        data: {
          stub : value,
          id: model.get('id')
        },
        type: 'post',
        dataType: 'html'
      });
    }
  },
  greaterThan: function(value, attr, minValue){
    if (hasValue(value)) {
      if (!isNumber(value) || value <= minValue) {
        return format(messages.min, attr, minValue);
      }
    }
  },
  acceptance: function(value, attr) {
    if (value !== 'true' && (!_.isBoolean(value) || value === false)) {
      return format(messages.acceptance, attr);
    }
  },
  isInteger: function(value, attr) {
    if (value % 1 !== 0) {
      return format(messages.isInteger, attr);
    }
  },
  isCurrency: function(value, attr) {
    var regex  = /^\d+(?:\.\d{0,2})$/;
    if (!regex.test(value)){
      return format(messages.isInteger, attr);
    }
  },
  min: function(value, attr, minValue, view, model) {
    var minValue = _.isFunction(minValue) ? minValue.call(view) : minValue;
    if (hasValue(value)) {
      if (!isNumber(value) || value < minValue) {
        return format(messages.min, attr, minValue);
      }
    }
  },
  max: function(value, attr, maxValue) {
    if (!isNumber(value) || value > maxValue) {
      return format(messages.max, attr, maxValue);
    }
  },
  range: function(value, attr, range) {
    if (!isNumber(value) || value < range[0] || value > range[1]) {
      return format(messages.range, attr, range[0], range[1]);
    }
  },
  length: function(value, attr, length) {
    if (!hasValue(value) || trim(value).length !== length) {
      return format(messages.length, attr, length);
    }
  },
  minLength: function(value, attr, minLength) {
    if (!hasValue(value) || trim(value).length < minLength) {
      return format(messages.minLength, attr, minLength);
    }
  },
  maxLength: function(value, attr, maxLength) {
    if (!hasValue(value) || trim(value).length > maxLength) {
      return format(messages.maxLength, attr, maxLength);
    }
  },
  rangeLength: function(value, attr, range) {
    if (!hasValue(value) || trim(value).length < range[0] || trim(value).length > range[1]) {
      return format(messages.rangeLength, attr, range[0], range[1]);
    }
  },
  oneOf: function(value, attr, values) {
    if (!_.include(values, value)) {
      return format(messages.oneOf, attr, values.join(', '));
    }
  },
  equalTo: function(value, attr, equalTo, view, model) {
    if (value !== model.get(equalTo)) {
      return format(messages.equalTo, attr, equalTo);
    }
  },
  pattern: function(value, attr, pattern) {
    if (hasValue(value)) {
      if (!value.toString().match(patterns[pattern] || pattern)) {
        return format(messages.pattern, attr, pattern);
      }
    }
  }
};
}(Backbone.Validation.patterns, Backbone.Validation.messages, _));
